import { render, staticRenderFns } from "./asdsidebar.vue?vue&type=template&id=34bd9684&scoped=true"
import script from "./asdsidebar.vue?vue&type=script&lang=js"
export * from "./asdsidebar.vue?vue&type=script&lang=js"
import style0 from "./asdsidebar.vue?vue&type=style&index=0&id=34bd9684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bd9684",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VIcon,VSpacer})
